import React, { createContext, useState, useEffect } from 'react';
import {
  get_all_stores
} from './Services/Stores.js';

const GlobalContext = createContext();
let currentStore = null;

export default GlobalContext;

export const getGlobalStore = () => currentStore;

export const GlobalProvider = ({ children }) => {
  
  const [stores, setStores] = useState([]);
  const [store, setStore] = useState(null);

  useEffect(() => {
    currentStore = store;
  }, [store])

  return (
    <GlobalContext.Provider value={{ store, setStore, stores }}>
      {children}
    </GlobalContext.Provider>
  );
};